export class ThemeEvents {
  static cartUpdate = 'cart:update';
  static cartError = 'cart:error';
  static discountUpdate = 'discount:update';
  static drawerOpen = 'medistik:drawer:open';
  static drawerClose = 'medistik:drawer:close';
  static legacyCartDrawerOpen = 'medistik:cart-drawer:open';
  static legacyCartDrawerClose = 'medistik:cart-drawer:close';
  static quantitySelectorUpdate = 'quantity-selector:update';
  static variantChange = 'medistik:variant:change';
  static sectionRender = 'medistik:section:render';
}

function cartFromResource(resource, data = {}) {
  return data.cart || resource?.cart || resource || null;
}

function sectionsFromResource(resource, data = {}) {
  return data.sections || resource?.sections || {};
}

function eventDetail(resource = null, sourceId = '', data = {}) {
  const source = data.source || sourceId || '';

  return {
    resource,
    source,
    sourceId,
    sections: sectionsFromResource(resource, data),
    cart: cartFromResource(resource, data),
    error: data.error || null,
    data: {
      source,
      ...data,
    },
  };
}

export class CartAddEvent extends Event {
  static eventName = ThemeEvents.cartUpdate;

  constructor(resource = null, sourceId = '', data = {}) {
    super(CartAddEvent.eventName, { bubbles: true });
    this.detail = eventDetail(resource, sourceId, {
      source: 'product-form',
      ...data,
    });
  }
}

export class CartUpdateEvent extends Event {
  constructor(resource = null, sourceId = '', data = {}) {
    super(ThemeEvents.cartUpdate, { bubbles: true });
    this.detail = eventDetail(resource, sourceId, {
      source: 'cart',
      ...data,
    });
  }
}

export class CartErrorEvent extends Event {
  constructor(sourceId = '', message = 'Unable to update cart.', description = '', errors = null) {
    super(ThemeEvents.cartError, { bubbles: true });
    const error = {
      message,
      description,
      errors,
    };

    this.detail = {
      resource: null,
      source: sourceId,
      sourceId,
      sections: {},
      cart: null,
      error,
      data: {
        error,
        message,
        description,
        errors,
      },
    };
  }
}

export class DiscountUpdateEvent extends Event {
  constructor(resource = null, sourceId = '', data = {}) {
    super(ThemeEvents.discountUpdate, { bubbles: true });
    this.detail = eventDetail(resource, sourceId, {
      source: 'discount',
      ...data,
    });
  }
}

export class QuantitySelectorUpdateEvent extends Event {
  constructor(quantity, cartLine = null, sourceId = '') {
    super(ThemeEvents.quantitySelectorUpdate, { bubbles: true });
    this.detail = {
      resource: null,
      source: sourceId,
      sourceId,
      sections: {},
      cart: null,
      error: null,
      quantity,
      cartLine,
      data: {
        source: sourceId,
        quantity,
        cartLine,
      },
    };
  }
}

export function dispatchThemeEvent(target, type, detail = {}) {
  target.dispatchEvent(
    new CustomEvent(type, {
      bubbles: true,
      cancelable: false,
      detail,
    }),
  );
}

window.MedistikEvents = {
  ThemeEvents,
  CartAddEvent,
  CartUpdateEvent,
  CartErrorEvent,
  DiscountUpdateEvent,
  QuantitySelectorUpdateEvent,
  dispatchThemeEvent,
};
